import firebase from "./config";
import { Card, Image } from "antd";
import "./App.css";
import { useState, useEffect } from "react";

const todoRef = firebase.database().ref("url/");
const { Meta } = Card;

export default function ProdottiOnline() {
  const [info, setInfo] = useState([]);
  useEffect(() => {
    todoRef.on("value", function (snapshot) {
      const obj = snapshot.val();
      console.log(Object.values(obj));
      setInfo(Object.values(obj));
    });
  }, []);

  return (
    <div className="prodottiOnline">
      {info.map((e) => {
        return (
          <div className="cardOnline ">
            <Card
              className="cart"
              hoverable
              style={{ width: 240 }}
              cover={
                <Image className="immagineCover" width={200} src={e.link} />
              }
            >
              <Meta title={`${e.titolo}`} description={e.catego} />
              <h3>{e.prezzo}</h3>
              <p>Prezzo vecchio: {e.prezzoVecchio}€</p>
            </Card>
          </div>
        );
      })}
    </div>
  );
}
